//33
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import {
  RetreatFabricMaterial,
  RetreatLegMaterial,
} from '../../utils/materials';

export function Retreat_monterey_chair(props) {
  const { nodes, materials, scene } = useGLTF('models/Monterey Chair.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);
  // uuid 33
  useSetMaterialFinish(
    RetreatFabricMaterial,
    currentMaterialFinish.retreatFabricFinish,
    defaultFinish.retreatFabricFinish,
    'ao-monterey_chair-retreat_fabrics',
    aoIntensity,
  );
  // ao not found for leg finish
  useSetMaterialFinish(
    RetreatLegMaterial,
    currentMaterialFinish.retreatLegFinish,
    defaultFinish.retreatLegFinish,
    // 'setfile',
    // aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Retreat_Leg_Finish.geometry}
        material={RetreatLegMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.Retreat_Fabrics.geometry}
        material={RetreatFabricMaterial}
      />
      <Shadow model={'Monterey Chair'} />
    </group>
  );
}
